/**
 * Eagle Bourbon — Collection Page JS
 * assets/eagle-collection.js
 *
 * Handles: sidebar filter apply/clear, desktop sort dropdown,
 * mobile filter drawer, mobile sort sheet, active pill removal, ATC
 */
(function () {
  'use strict';

  /* ── Refs ── */
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); };

  var drawerOverlay   = $('.ecol-drawer-overlay');
  var drawer          = $('.ecol-drawer');
  var drawerClose     = $('.ecol-drawer__close');
  var drawerApply     = $('.ecol-drawer__apply');
  var drawerClear     = $('.ecol-drawer__clear');
  var filterBtn       = $('.ecol-toolbar__btn--filter');
  var sortBtnMobile   = $('.ecol-toolbar__btn--sort');
  var sortSheet       = $('.ecol-sort-sheet');
  var sortSheetClose  = $('.ecol-sort-sheet__close');
  var sidebarApply    = $('#ecol-sidebar-apply');
  var sidebarClear    = $('#ecol-sidebar-clear');
  var sortBtnDesktop  = $('#ecol-sort-btn');
  var sortDropdown    = $('#ecol-sort-dropdown');
  var grid            = $('#ecol-grid');

  /* ─────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────── */
  function buildFilterURL(checkboxes, priceInputs) {
    var url = new URL(window.location.href);
    var params = url.searchParams;

    /* Remove existing filter.* and page params */
    Array.from(params.keys()).forEach(function (k) {
      if (k.startsWith('filter.') || k === 'page') params.delete(k);
    });

    /* Add checked boxes */
    checkboxes.forEach(function (cb) {
      if (cb.checked) params.append(cb.name, cb.value);
    });

    /* Add price inputs */
    priceInputs.forEach(function (inp) {
      var v = inp.value.trim();
      if (v !== '') params.set(inp.name, v);
    });

    return url.toString();
  }

  function getFilterInputs(container) {
    return {
      checks: $$(
        'input[type="checkbox"].ecol-sidebar__checkbox, .ecol-filter-group__options input[type="checkbox"]',
        container || document
      ),
      prices: $$('.ecol-price-range__field', container || document)
    };
  }

  function lockScroll()   { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.body.style.overflow = ''; }

  /* ─────────────────────────────────────────
     MOBILE FILTER DRAWER
  ───────────────────────────────────────── */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawerOverlay.classList.add('is-open');
    lockScroll();
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawerOverlay.classList.remove('is-open');
    unlockScroll();
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
  }

  if (filterBtn)    filterBtn.addEventListener('click', openDrawer);
  if (drawerClose)  drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', function (e) {
    if (e.target === drawerOverlay) { closeDrawer(); closeSortSheet(); }
  });

  /* Drawer apply */
  if (drawerApply) {
    drawerApply.addEventListener('click', function () {
      var inputs = getFilterInputs(drawer);
      window.location.href = buildFilterURL(inputs.checks, inputs.prices);
    });
  }

  /* Drawer clear */
  if (drawerClear) {
    drawerClear.addEventListener('click', function () {
      $$('input[type="checkbox"]', drawer).forEach(function (cb) { cb.checked = false; });
      $$('.ecol-price-range__field', drawer).forEach(function (f) { f.value = ''; });
    });
  }

  /* Drawer filter group accordions */
  $$('.ecol-filter-group__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var group = toggle.closest('.ecol-filter-group');
      var isOpen = group.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  });

  /* ─────────────────────────────────────────
     SIDEBAR — apply / clear
  ───────────────────────────────────────── */
  if (sidebarApply) {
    sidebarApply.addEventListener('click', function () {
      var inputs = getFilterInputs($('.ecol-sidebar'));
      window.location.href = buildFilterURL(inputs.checks, inputs.prices);
    });
  }

  if (sidebarClear) {
    sidebarClear.addEventListener('click', function () {
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (k) {
        if (k.startsWith('filter.') || k === 'page') url.searchParams.delete(k);
      });
      window.location.href = url.toString();
    });
  }

  /* ─────────────────────────────────────────
     DESKTOP SORT DROPDOWN
  ───────────────────────────────────────── */
  function openSortDropdown() {
    if (!sortDropdown) return;
    sortDropdown.classList.add('is-open');
    sortBtnDesktop.classList.add('is-open');
    sortBtnDesktop.setAttribute('aria-expanded', 'true');
  }

  function closeSortDropdown() {
    if (!sortDropdown) return;
    sortDropdown.classList.remove('is-open');
    sortBtnDesktop && sortBtnDesktop.classList.remove('is-open');
    sortBtnDesktop && sortBtnDesktop.setAttribute('aria-expanded', 'false');
  }

  if (sortBtnDesktop) {
    sortBtnDesktop.addEventListener('click', function (e) {
      e.stopPropagation();
      sortDropdown.classList.contains('is-open') ? closeSortDropdown() : openSortDropdown();
    });
  }

  /* ─────────────────────────────────────────
     MOBILE SORT SHEET
  ───────────────────────────────────────── */
  function openSortSheet() {
    if (!sortSheet) return;
    sortSheet.classList.add('is-open');
    drawerOverlay.classList.add('is-open');
    lockScroll();
  }

  function closeSortSheet() {
    if (!sortSheet) return;
    sortSheet.classList.remove('is-open');
    if (!drawer || !drawer.classList.contains('is-open')) {
      drawerOverlay.classList.remove('is-open');
      unlockScroll();
    }
  }

  if (sortBtnMobile) sortBtnMobile.addEventListener('click', openSortSheet);
  if (sortSheetClose) sortSheetClose.addEventListener('click', closeSortSheet);

  /* ─────────────────────────────────────────
     SORT OPTION CLICK (both dropdown + sheet)
  ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.ecol-sort-option');
    if (opt && opt.dataset.sort !== undefined) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', opt.dataset.sort);
      url.searchParams.delete('page');
      window.location.href = url.toString();
      return;
    }

    /* Close sort dropdown if click outside */
    if (sortDropdown && sortDropdown.classList.contains('is-open')) {
      if (!sortDropdown.contains(e.target) && e.target !== sortBtnDesktop) {
        closeSortDropdown();
      }
    }
  });

  /* ─────────────────────────────────────────
     ACTIVE FILTER PILL — remove on click
  ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ecol-pill[data-remove-name]');
    if (!pill) return;
    var url     = new URL(window.location.href);
    var name    = pill.dataset.removeName;
    var val     = pill.dataset.removeValue;
    var existing = url.searchParams.getAll(name);
    url.searchParams.delete(name);
    existing.forEach(function (v) {
      if (v !== val) url.searchParams.append(name, v);
    });
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ─────────────────────────────────────────
     ADD TO CART
  ───────────────────────────────────────── */
  if (grid) {
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.ecol-card__atc');
      if (!btn || btn.disabled || btn.classList.contains('ecol-card__atc--soldout')) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      var orig = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Error');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = 'ADDED ✓';

        /* Update cart bubble */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            $$('[data-cart-count], .cart-count-bubble, .js-cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });

        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = orig;
        }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = orig;
        alert('Could not add to cart. Please try again.');
      });
    });
  }

  /* ─────────────────────────────────────────
     KEYBOARD — Escape closes overlays
  ───────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeSortSheet();
      closeSortDropdown();
    }
  });

})();